import React from 'react';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { Stepper } from '@utriper/core-ui';
import { Box, useMediaQuery } from '@mui/material';
import ExperienceDataForm from './components/ExperienceDataForm';
import LocationForm from './components/LocationForm';
import PriceForm from './components/PriceForm';
import MultimediaForm from './components/MultimediaForm';
import PoliciesForm from './components/PoliciesForm';
import IncludesForm from './components/IncludesForm';
import EcoMessageForm from './components/EcoMessageForm';
import SuccessPage from './components/SuccessPage';

const ExperienceForm = ({ activeStep }) => {
    switch (activeStep) {
        case 0:
            return <ExperienceDataForm />;
        case 1:
            return <LocationForm />;
        case 2:
            return <PriceForm />;
        case 3:
            return <MultimediaForm />;
        case 4:
            return <PoliciesForm />;
        case 5:
            return <IncludesForm />;
        case 6:
            return <EcoMessageForm />;
        default:
            return null;
    }
};

const ExperienceWizardPage = () => {
    const { t: translate } = useTranslation();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const { steps, activeStep, isSuccess } = useExperienceWizard();

    const title = translate('experience_wizard.title');

    if (isSuccess) {
        return <SuccessPage />;
    }

    return (
        <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', gap: '2rem', width: '100%', minHeight: '100dvh', overflow: 'hidden' }}>
            {isMobile ? (
                <Stepper title={title} steps={steps} activeStep={activeStep} />
            ) : (
                <Box sx={{ maxWidth: '500px', width: '100%' }}>
                    <Stepper title={title} steps={steps} activeStep={activeStep} />
                </Box>
            )}

            <Box sx={{ flexGrow: isMobile ? 0 : 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, pt: isMobile ? '6rem' : 2, maxWidth: '100%' }}>
                <ExperienceForm activeStep={activeStep} />
            </Box>
        </Box>
    );
};

export default ExperienceWizardPage;
